/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabSample from './diaglab-sample';
import DiaglabSampleDetail from './diaglab-sample-detail';
import DiaglabSampleUpdate from './diaglab-sample-update';
import DiaglabSampleDeleteDialog from './diaglab-sample-delete-dialog';

const DiaglabSampleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabSample />} />
    <Route path="new" element={<DiaglabSampleUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabSampleDetail />} />
      <Route path="edit" element={<DiaglabSampleUpdate />} />
      <Route path="delete" element={<DiaglabSampleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabSampleRoutes;
